<template>
    <div>
        <v-layout row wrap>
            <v-flex sm12 md3 style="padding: 0 5px 0 5px">
                <v-card>
                    <v-toolbar class="primary-color" dense flat dark>
                        Search &amp; Filtering
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field 
                            v-model="searchText" 
                            append-icon="search" 
                            label="Search Phone Number" 
                            single-line 
                            hide-details
                            @keyup.enter="search" 
                        />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn @click="searchText='';search()">
                            Clear
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="search()"
                        >
                            Search
                        </v-btn>
                        <v-spacer/>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex sm12 md9>
                <v-card>
                    <v-toolbar flat color="primary" dark dense>
                        SMS Bounces
                    </v-toolbar>
                    <v-card-text style="padding: 0;">
                        <v-alert
                            :value="true"
                            type="error"
                        >
                            SMS Bounces are permanent and cannot be released due to upstream provider policies. For more information on a message failure, contact support with a Provider SID.
                        </v-alert>
                        <v-data-table 
                            :items="bounces" 
                            :headers="headers" 
                            :pagination.sync="pagination"
                            :total-items="totalBounces" 
                            :rows-per-page-items="paginationStrings" 
                            :loading="loading"
                            item-key="sid" 
                            disable-initial-sort
                        >
                            <template v-slot:no-data>
                                <tr>
                                    <td :colspan="headers.length">
                                        <div style="text-align: center; padding:25px;">
                                            <v-icon size="125px">find_in_page</v-icon>
                                            <h3>No Results</h3>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template slot="items" slot-scope="item">
                                <tr>
                                    <td>
                                        <b>{{ item.item.phone_number }}</b>
                                    </td>
                                    <td>
                                        {{ convertToLocal(item.item.sent_at) }}
                                    </td>
                                    <td
                                        style="text-transform: capitalize;"
                                    >
                                        {{ item.item.status }}
                                    </td>
                                    <td style="text-align: center">
                                        <v-icon @click="item.expanded = !item.expanded">mdi-chevron-down</v-icon>
                                    </td>
                                </tr>
                            </template>
                            <template slot="expand" slot-scope="item">
                                <v-card>
                                    <v-card-text>
                                        <div>
                                            <b>Provider SID: </b> {{ item.item.sid }}
                                        </div>
                                        <div>
                                            <b>Status: </b> {{ item.item.status }}
                                        </div>
                                        <div>
                                            <b>Response Code: </b> {{ item.item.error }}
                                        </div>
                                        <div
                                            v-if="item.item.last_message"
                                        >
                                            <b>Error Details: </b> {{ item.item.last_message }}
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </template>
                            <template slot="actions-append">
                                <v-tooltip left>
                                    <v-btn
                                        round
                                        flat
                                        fab
                                        small
                                        @click="downloadCsv()"
                                        slot="activator"
                                    >
                                        <v-icon
                                            color="green"
                                        >   
                                            table_chart
                                        </v-icon>
                                    </v-btn>
                                    <span>Download CSV<br /><small>Of Current Search Terms</small></span>
                                </v-tooltip>
                            </template>
                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import api from '@/api'
import pagination from '@/components/global/pagination'

export default {
    name: 'OrgSmsBounces',
    mixins: [
        pagination
    ],
    data() {
        return {
            searchText: '',
            bounces: [],
            emailRadio: '',
            headers: [
                { text: 'Phone Number', value: 'phone_number', sortable: false },
                { text: 'Sent', value: 'sent_at' },
                { text: 'Status', value: 'status', sortable: false },
                { text: 'More Info', align: 'center', sortable: false }
            ],
            pagination: {},
            paginationStrings: [
                10, 25, 50
            ],
            expanded: [],
            loading: true,
            filter: null,
            ignoring: null
        }
    },
    computed: {
        totalBounces() {
            return this.pagination.totalItems
        }
    },
    methods: {
        fetch() {
            this.loading = true
            api.sms.problems.list({
                search: this.searchText, 
                ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, 
                pageNum: this.pagination.page, 
                count: this.pagination.rowsPerPage,
                filter: this.filter || null
            }).then(data => {
                this.bounces = data.results
                this.pagination.page = data.page_number
                this.pagination.totalItems = data.count
                this.componentCreated = true
                this.loading = false
            })
        },
        downloadCsv(){
            api.sms.problems.downloadCsv({
                search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, filter: this.emailRadio
            }).then(response => {
                let blob = new Blob([response.data])
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Export_SMSProblems.csv'
                link.click()
            })
        },
        search () {
            this.pagination.page = 1
            var queryParam = {}, filterQueryParam = {}
            if (this.searchText) {queryParam['search'] = this.searchText}
            if (this.emailRadio) {filterQueryParam['type'] = this.emailRadio}
            if (Object.keys(filterQueryParam).length !== 0) {queryParam['filter'] = JSON.stringify(filterQueryParam)}
            this.$router.push({ query: queryParam })
        }
    }
}
</script>
